import { t } from "i18next";
import React from "react";

import ApplicationLayout from "components/layout/ApplicationLayout";
import { SHARED_SETTINGS_ROUTE } from "components/router/Routes";
import { SharedSettingsSubpage } from "components/settings/views/shared-settings/SharedSettingsSubpage";

export const SharedSettingsView = () => {
    return (
        <ApplicationLayout
            viewTitle={t("Routes.sharedSettings")}
            view={<SharedSettingsSubpage />}
            mainRoute={SHARED_SETTINGS_ROUTE}
        />
    );
};
